import React from 'react';
import css from './StockEquipmentWidget.module.scss';
import { useTranslation } from 'react-i18next';
import ReachstackerWithPricetag from '../../assets/reachstacker-with-pricetag.svg';

export const StockEquipmentWidget: React.FC = () => {
    const { t } = useTranslation('StockEquipment');

    return (
        <div className={css.iconContainer}>
            <ReachstackerWithPricetag className={css.icon} />
            <div className={css.text}>{t('See all stock equipment ready to deliver')}</div>
        </div>
    );
};
